import { getRelateDeductDetail } from '@/api/receivables';

const relateDeductDetailMixins = {
  data() {
    return {
      relateDeductDetailData: [],
    };
  },
  methods: {
    async _getRelateDeductDetail(params) {
      try {
        const res = await getRelateDeductDetail(params);
        this.relateDeductDetailData = res?.data || [];
      } catch (error) {
        console.log(error);
      }
    },
  },
};

export default relateDeductDetailMixins;
